// extracted by mini-css-extract-plugin
export default {"host":"style_host__B+ljL","tab":"style_tab__WWu5V","active":"style_active__wmRNQ","count":"style_count__ybyyw"};